const connectCreatorAccount = () => {};

export default connectCreatorAccount;
